module.exports = __webpack_public_path__ + "static/media/20210409_195306_992_IMG_0098.29798764.jpg";